import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import type { GetRootState } from 'js/src/libs/RootState';
import type Luminary from '@lumen5/luminary';

import type { LintFinding } from '../videoLinter';

import {
    formatUncoveredRanges,
    getUncoveredTranscriptRanges,
} from 'js/src/agent/tools/overlay-coverage';

/**
 * Error: a voiceover scene group has transcript ranges not covered by an
 * overlay scene, so the voiceover waveform base is visible there — a finished
 * voiceover video should have full overlay coverage.
 */
export function checkOverlayCoverage(luminary: Luminary, getState: GetRootState): LintFinding[] {
    const findings: LintFinding[] = [];
    const state = getState();

    luminary.sceneGroups.forEach((sceneGroup, sceneGroupIndex) => {
        const ranges = getUncoveredTranscriptRanges(state, sceneGroup);
        if (ranges === null || ranges.length === 0) {
            return;
        }
        findings.push({
            check: 'overlay_coverage',
            severity: 'error',
            sceneGroupIndex,
            message: `${formatUncoveredRanges(ranges)}\nLoad the ${SKILL_NAMES.voiceoverVideoBasics} skill for the coverage-repair procedure.`,
        });
    });

    return findings;
}
